define(function (require) {
    "use strict";

    var LE = require("app");
    var Loader = require("ui/loader/Loader");
    var Checkbox = require("ui/checkbox/Checkbox");
    var template = require("content-templates/content-gallery/system/contentSystemTableRowView.tmpl");
    var PlusCompositeView = require('ui/plus-composite-view/PlusCompositeView');
    var ContentSystemModel = require("content-models/system/ContentSystemModel");

    var ContentSystemTableRowView = {};
    var TRANSLATIONS =  {
        statusEnabledText:  LE.translator.translate("LEContent.content.contentTable.status.enabled"),
        statusDisabledText: LE.translator.translate("LEContent.content.contentTable.status.disabled"),
        statusMultipleText:  LE.translator.translate("LEContent.content.contentTable.status.multiple")
    };

    LE.module('LEContent', function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentSystemTableRowView = Marionette.ItemView.extend({

            template:template,
            tagName:'tr',
            className:'content_row',
            loaders:[],
            withUIComponents: true,
            ui:{
                selector:'.selector',
                status:  '.status',
                name:'.name>.value',
                languageContainer:    '.languages-container',
                skills:               '.skills',
                skillsContainer:      '.skills-container'
            },

            events:{
                "click .name":"editItem",
                "click .languages-container":"editItem",
                "click .skills":       "editItem",
                "click .status":       "editItem"
            },

            modelEvents: {
                "change:contexts.SKILL": "_updateSkill"
            },


            //--------------------------------------------------
            // initialize
            //--------------------------------------------------

            initialize : function (options) {
                this.channel = options.channel;
                this.model.resetLanguageContentMap();
                this.isAcUser = LE.siteSettings.accountSettings.isAcUser();
            },

            //-----------------------------------------------------
            // onRender
            //-----------------------------------------------------

            onRender:function () {
                this.setCheckBox();
                this.setNameText();
                this.setSkills();
                this.setStatusText();
            },

            //--------------------------------------------

            setCheckBox:function () {
                this.chkBox = new Checkbox({
                    checked:false,
                    label:'',
                    permutation: Checkbox.PERMUTATION.B,
                    el:this.ui.selector
                });
                this.chkBox.render();

                this.ui.selector.on('click', _.bind(function (e) {
                    if ($(e.target).hasClass('selector')) {
                        this.chkBox.checkboxClick(e);
                    }
                }, this));
                this.listenTo(this.chkBox, Checkbox.TRIGGERING.CHANGE, this.onRowSelect);
            },

            setNameText:function () {
                var name = this.model.getName();
                if (_.isEmpty(name)) {
                    this.ui.name.text(LE.translator.translate("LEContent.content.edit.canned.no-title.available.label"));
                    this.ui.name.attr("title",LE.translator.translate("LEContent.content.edit.canned.no-title.available.tooltip"));
                    this.ui.name.attr("tooltip-align","left");
                } else {
                    this.ui.name.text(name);
                }
            },

            setSkills: function() {
                if (this.uiComponents && this.uiComponents.skillsComponent) {
                    this.uiComponents.skillsComponent.close();
                }

                this.uiComponents.host$.createAndRender("skillsComponent", {
                    type: PlusCompositeView,
                    options: {
                        el: "view.ui.skillsContainer",
                        collection: "view._buildSkillsList",
                        textModelAttr: "tooltip",
                        visibleItemsCount: 1,
                        itemView: PlusCompositeView.DefaultPlusComponentItemView
                    }
                });
            },

            setStatusText:function () {
                var statusText = TRANSLATIONS.statusEnabledText;
                var status = this.model.getStatusState();
                if(ContentSystemModel.STATUS.MULTIPLE === status) {
                    statusText = TRANSLATIONS.statusMultipleText;
                } else if(ContentSystemModel.STATUS.DISABLED === status){
                    statusText = TRANSLATIONS.statusDisabledText;
                }
                this.ui.status.text(statusText);
            },


            //--------------------------------------------
            // selectRow
            //--------------------------------------------

            onRowSelect:function () {
                var checked = this.chkBox.isChecked();
                this.trigger("select:clicked", checked);
            },

            //--------------------------------------------

            selectRow:function (checked) {
                if (checked) {
                    this.$el.addClass("selected");
                } else {
                    this.$el.removeClass("selected");
                }
                this.chkBox.setCheckedState(checked);
            },


            //--------------------------------------------
            // editItem
            //--------------------------------------------

            editItem:function (ev) {
                this.channel.trigger("contentSystemGalleryTable:editItem", {model:this.model});
            },

            //--------------------------------------------------------

            _buildSkillsList: function(){
                var skillsCollection = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getSkillsCollection);
                var res = [];
                _.each(this.model.getSkills(),function(skill){
                    var skillModel = skillsCollection.get(skill.skillId);
                    if (skillModel){
                        res.push({
                            name: skillModel.getName(),
                            tooltip: skillModel.getName(),
                            activeTooltip: true
                        });
                    } else{
                        LEContent.logger.graph({name: "content:ContentSystemTableRowView:_buildSkillsList:skillModelNotExist" });
                        LEContent.logger.error("Could not find skill id " + skill.skillId + " in skills collection","ContentSystemTableRowView:_buildSkillsList");
                    }
                });
                this._sortListByName(res);
                return new PlusCompositeView.DefaultPlusComponentCollection(res);
            },

            _updateSkill: function() {
                this.setSkills();
            },

            _sortListByName: function(arrayOfObjects){
                arrayOfObjects.sort(function(a, b){
                    return a.name.toLowerCase() > b.name.toLowerCase() ? 1:-1;
                });
            }
        });
    });

    return ContentSystemTableRowView;
});
